export default {
  baseApiUrl: '/ajax/',
  baseLanguage: 'EN',
  countryLocales: {
    'EE': 'ET',
    'FI': 'FI',
    'FR': 'FR',
    'LT': 'LT',
    'LV': 'LV',
    'SE': 'SV'
  }
}
